import getRoomFreeBusyTextAndStyle from './utils/getRoomFreeBusyTextAndStyle';
import { useClientStyles } from 'owa-react-hooks/lib/useClientStyles';
import { observer } from 'mobx-react-lite';
import { Icon } from '@fluentui/react/lib/Icon';
import { ControlIcons } from 'owa-control-icons';
import { isFeatureEnabled } from 'owa-feature-flags';
import { Room, RoomAvailability } from './RoomSelector.types';
import * as React from 'react';

export interface RoomPersonaDetailsProps {
    room: Room;
    roomAvailability: RoomAvailability;
}

const styles = {
    base: require('./RoomPersonaDetails.scss'),
    desktop: require('./RoomPersonaDetails.outlookdesktop.scss'),
    mac: require('./RoomPersonaDetails.macoutlook.scss'),
};

/**
 * A summary of secondary text in the room persona component
 */
export default observer(function RoomPersonaDetails(props: RoomPersonaDetailsProps) {
    const { getClass } = useClientStyles(styles);
    const { text, textStyle } = getRoomFreeBusyTextAndStyle(
        props.roomAvailability,
        props.room.bookingType
    );

    const shouldRenderCapabilities: boolean =
        isFeatureEnabled('cal-advancedRoomBooking') &&
        !!(
            props.room.audioDeviceName ||
            props.room.displayDeviceName ||
            props.room.videoDeviceName ||
            props.room.isWheelChairAccessible
        );

    return (
        <>
            <span className={textStyle}>
                <Icon iconName={ControlIcons.Clock} className={getClass('icon')} />
                <span className={getClass('roomSecondaryText')}>{text}</span>
            </span>
            {isFeatureEnabled('cal-advancedRoomBooking') &&
                props.room.capacity != null &&
                props.room.capacity > 0 && (
                    <span>
                        <Icon
                            iconName={ControlIcons.Contact}
                            className={getClass('roomSecondaryTextIcon')}
                        />
                        <span className={getClass('roomSecondaryText')}>{props.room.capacity}</span>
                    </span>
                )}
            {isFeatureEnabled('cal-advancedRoomBooking') && props.room.city && (
                <span>
                    <Icon
                        iconName={ControlIcons.POI}
                        className={getClass('roomSecondaryTextIcon')}
                    />
                    <span className={getClass('roomSecondaryText')}>{props.room.city}</span>
                </span>
            )}
            {shouldRenderCapabilities && (
                <span>
                    {props.room.audioDeviceName && (
                        <Icon
                            iconName={ControlIcons.Volume2}
                            className={getClass('roomSecondaryCapabilityIcon')}
                        />
                    )}
                    {props.room.displayDeviceName && (
                        <Icon
                            iconName={ControlIcons.TVMonitor}
                            className={getClass('roomSecondaryCapabilityIcon')}
                        />
                    )}
                    {props.room.videoDeviceName && (
                        <Icon
                            iconName={ControlIcons.Video}
                            className={getClass('roomSecondaryCapabilityIcon')}
                        />
                    )}
                    {props.room.isWheelChairAccessible && (
                        <Icon
                            iconName={ControlIcons.EaseOfAccess}
                            className={getClass('roomSecondaryCapabilityIcon')}
                        />
                    )}
                </span>
            )}
        </>
    );
});
